import type { Proposta, PropostaItem } from '@/types'

export function getProposalItems(proposta: Proposta): PropostaItem[] {
  return proposta.itens ?? proposta.items ?? []
}

export function hasProposalContent(
  proposals: Proposta[],
  draftItens: PropostaItem[] = [],
): boolean {
  if (draftItens.length > 0) return true
  return proposals.some((p) => getProposalItems(p).length > 0)
}
